import React, {Component} from 'react';
import {Route, Redirect} from 'react-router-dom';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import ReportMenu from './ReportMenu';
import ReportCommesse from './ReportCommesse';
import ReportReddittivitaCommesse from './ReportReddittivitaCommesse';
import ReportMovimenti from './ReportMovimenti';
import ReportAttivita from './ReportAttivita';
import ReportAttivitaCommessaUtente from './ReportAttivitaCommessaUtente';
import ReportAttivitaGiornoSessione from "./ReportAttivitaGiornoSessione";
import ReportAttivitaAnnuale from './ReportAttivitaAnnuale';
import ReportAttivitaGiornaliero from './ReportAttivitaGiornaliero';
import ReportAttivitaDettagliato from './ReportAttivitaDettagliato';
import {createInstance} from '../../Helpers';

class ReportContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div>
      <Route exact path='/app/report' render={() => (
          <Redirect
              to='/app/report/menu'
          />
      )} />
      <MatchWhenLoggedIn path='/app/report/menu' component={ReportMenu} />
      <MatchWhenLoggedIn path='/app/report/commesse' component={ReportCommesse} instance={createInstance()} />
      <MatchWhenLoggedIn path='/app/report/reddittivita' component={ReportReddittivitaCommesse} instance={createInstance()} />
      <MatchWhenLoggedIn path='/app/report/movimenti' component={ReportMovimenti} instance={createInstance()} tipo="pdc" />
      <MatchWhenLoggedIn path='/app/report/movimentiec' component={ReportMovimenti} instance={createInstance()} tipo="ec"/>
      <MatchWhenLoggedIn path='/app/report/attivita' component={ReportAttivita} instance={createInstance()} />
      <MatchWhenLoggedIn path='/app/report/attivitaperanno' component={ReportAttivitaAnnuale} instance={createInstance()} />
      <MatchWhenLoggedIn path='/app/report/attivitadettagliato' component={ReportAttivitaDettagliato} instance={createInstance()} />
      <MatchWhenLoggedIn path='/app/report/attivitapergiorno' component={ReportAttivitaGiornaliero} instance={createInstance()} />
      <MatchWhenLoggedIn path='/app/report/attivitacu' component={ReportAttivitaCommessaUtente} instance={createInstance()} />
      <MatchWhenLoggedIn path='/app/report/attivitags' component={ReportAttivitaGiornoSessione} instance={createInstance()} />
    </div>)
  }
}

export default ReportContent;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportContent.js
 **/